import React, { useState, useRef } from 'react';

import { Growl } from 'primereact/growl';
import { AgregarEmpresa } from './AgregarEmpresa';
import { FormularioBusqueda } from './FormularioBusqueda';
import { Tabla } from './Tabla';

export const Empresa = () => {

    let growl = useRef(null);

    const [objetoFormulario,setObjetoFormulario] =useState({});
    const funcionFormulario = (objetoFormulario) =>{
        setObjetoFormulario(objetoFormulario);
    }

    const funcionRecargaTabla = () => {
        setObjetoFormulario({});
    }

    return (
        <div >
            <Growl ref={growl} />
            <AgregarEmpresa funcionRecargaTabla={funcionRecargaTabla}/>
            <FormularioBusqueda funcionExito = {funcionFormulario}/>
            <Tabla restriccionesBusqueda={objetoFormulario}/>
        </div>
    );
}